// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client';
import { processChainKeys } from '../query-keys';
import {
  createProcessChainContract,
  editProcessChainContract,
  deleteProcessChainContract,
  type CreateProcessChainRequest,
  type CreateProcessChainResponse,
  type EditProcessChainRequest,
  type EditProcessChainResponse,
  type DeleteProcessChainResponse
} from '@bliks-io/contracts';

// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

export function useCreateProcessChain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateProcessChainRequest): Promise<CreateProcessChainResponse> => {
      const { data: response } = await apiClient.post<CreateProcessChainResponse>(
        createProcessChainContract.path,
        data
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: processChainKeys.all });
    }
  });
}

export function useEditProcessChain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      ...data
    }: EditProcessChainRequest & { id: string }): Promise<EditProcessChainResponse> => {
      const { data: response } = await apiClient.put<EditProcessChainResponse>(
        editProcessChainContract.path.replace(':id', id),
        data
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: processChainKeys.all });
    }
  });
}

export function useDeleteProcessChain() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<DeleteProcessChainResponse> => {
      const { data: response } = await apiClient.delete<DeleteProcessChainResponse>(
        deleteProcessChainContract.path.replace(':id', id)
      );
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: processChainKeys.all });
    }
  });
}
